import { MenuItem } from "../menu/provider/MenuItem";
import {
  MenuProvider,
  vsProviderName as menuProviderName,
} from "../menu/provider/menuProvider";
import {
  vsName as menuServiceName,
  MenuService,
} from "../menu/provider/MenuService";
import {
  ProcessInformationService,
  vsServiceName as ProcessInformationServiceName,
} from "../Process/services/processInformationService";
import { ApplicationInfo } from "./appInfo";
import { vsName as userProfileName, UserProfile } from "./UserProfile";

export function menuRun(menuService: MenuService, userProfile: UserProfile) {
  menuService.setProfile(userProfile);
}
menuRun.$inject = [menuServiceName, userProfileName];

export function menuConfig(
  menuProvider: MenuProvider,
  applicationInfo: ApplicationInfo,
  clientName: string
) {
  const machineMenuItem: MenuItem | undefined = applicationInfo.isModuleLoaded(
    "machines"
  )
    ? machineMenu(clientName, applicationInfo)
    : undefined;
  const progressiveMenuItem: MenuItem | undefined =
    applicationInfo.isModuleLoaded("progressives")
      ? progressiveMenu()
      : undefined;
  const partsMenuItem: MenuItem | undefined = applicationInfo.isModuleLoaded(
    "parts"
  )
    ? partsMenu()
    : undefined;
  const workOrdersMenuItem: MenuItem | undefined = undefined;
  //applicationInfo.isModuleLoaded("workOrders") ? workOrdersMenu() : undefined;

  const contactBookMenuItem: MenuItem | undefined =
    applicationInfo.isModuleLoaded("SlotTrak.AddressBook")
      ? contactBookMenu(clientName, applicationInfo)
      : undefined;

  const projectCostMenuItem: MenuItem | undefined =
    applicationInfo.isModuleLoaded("SlotTrak.ProjectCost")
      ? projectCostMenu(clientName, applicationInfo)
      : undefined;

  const contractMenuItem: MenuItem | undefined = contractMenu(
    clientName,
    applicationInfo
  );

  const processMenuItem: MenuItem | undefined = undefined;
  /*applicationInfo.isModuleLoaded(
    "slotcheck"
  )
    ? processMenu(clientName, applicationInfo)
    : undefined;*/
  const usersMenuItem: MenuItem = userMenu(applicationInfo);

  const mealLogMenuItem = applicationInfo.isModuleLoaded("mealLog")
    ? mealLogMenu()
    : undefined;

  if (machineMenuItem !== undefined) {
    menuProvider.addMenuItem(machineMenuItem);
  }

  if (mealLogMenuItem !== undefined) {
    menuProvider.addMenuItem(mealLogMenuItem);
  }

  if (progressiveMenuItem !== undefined) {
    menuProvider.addMenuItem(progressiveMenuItem);
  }
  if (partsMenuItem !== undefined) {
    menuProvider.addMenuItem(partsMenuItem);
  }
  if (workOrdersMenuItem !== undefined) {
    menuProvider.addMenuItem(workOrdersMenuItem);
  }
  if (contactBookMenuItem !== undefined) {
    menuProvider.addMenuItem(contactBookMenuItem);
  }
  if (projectCostMenuItem !== undefined) {
    menuProvider.addMenuItem(projectCostMenuItem);
  }
  if (contractMenuItem !== undefined) {
    menuProvider.addMenuItem(contractMenuItem);
  }
  if (processMenuItem !== undefined) {
    menuProvider.addMenuItem(processMenuItem);
  }
  if (usersMenuItem !== undefined) {
    menuProvider.addMenuItem(usersMenuItem);
  }
}
menuConfig.$inject = [menuProviderName, "applicationInfo", "clientName"];

function mealLogMenu(): MenuItem {
  const mealLogMenuItem = new MenuItem({
    id: "machines.mealLog",
    state: "main.mealLog",
    display: "MEAL Log",
    imgSrc: require("../menu/img/up_down_arrow.png"),
    requiredPermission: "mealLogView",
  });

  mealLogMenuItem.addChild(
    new MenuItem({
      id: "machines.mealLog.lookups",
      state: "main.mealLog.lookups",
      display: "Lookup Management",
    })
  );

  return mealLogMenuItem;
}

function userMenu(applicationInfo: ApplicationInfo): MenuItem {
  const children: MenuItem[] = [
    new MenuItem({
      id: "users.roles",
      state: "main.users.roles.grid",
      activeOnState: "main.users.roles.**",
      display: "Roles",
      requiredPermission: "userModify",
    }),
    new MenuItem({
      id: "users.userPermissions",
      state: "main.users.userPermissions",
      display: "User Permissions",
      requiredPermission: "userModify",
    }),
  ];

  if (applicationInfo.isModuleLoaded("authentication.apiKey")) {
    children.push(
      new MenuItem({
        id: "users.apiKeys",
        state: "main.users.apiKey",
        display: "API Keys",
        requiredPermission: "adminApiKey",
      })
    );
  }

  const userMenu = new MenuItem({
    id: "users",
    display: "Users",
    state: "main.users.grid",
    activeOnState: "main.users.**",
    imgSrc: require("../menu/img/user_icon.png"),
    anyPermission: ["userModify", "userPasswordSet", "userLock"],
    children,
  });

  return userMenu;
}

function workOrdersMenu(): MenuItem {
  return new MenuItem({
    id: "workOrders",
    state: "main.workorders.grid",
    imgSrc: require("../menu/img/up_down_arrow.png"),
    display: "Work Orders",
    requiredPermission: "workOrderView",
  });
}

function processMenu(
  clientName: string,
  applicationInfo: ApplicationInfo
): MenuItem {
  const processMenuItem: MenuItem = new MenuItem({
    id: "Process",
    state: "main.processes.grid",
    display: "Process",
    //requiredPermission: "machineView",
    imgSrc: require("../menu/img/up_down_arrow.png"),
  });

  return processMenuItem;
}

function partsMenu(): MenuItem {
  return new MenuItem({
    id: "parts",
    state: "main.parts.main",
    activeOnState: "main.parts.**",
    display: "Parts",
    imgSrc: require("../menu/img/parts_icon.png"),
    requiredPermission: "partView",
    children: [
      new MenuItem({
        id: "parts.checkout",
        state: "main.parts.checkout",
        display: "Checkout",
        requiredPermission: "partCheckout",
      }),
      new MenuItem({
        id: "parts.orders",
        state: "main.parts.orders",
        display: "Orders",
        requiredPermission: "partOrderView",
      }),
      new MenuItem({
        id: "parts.checkedOut",
        state: "main.parts.checkedOut",
        display: "Checkout List",
        requiredPermission: "partCheckout",
      }),
      new MenuItem({
        id: "parts.partProperties",
        state: "main.parts.partProperties",
        display: "Part Rooms",
        requiredPermission: "partEdit",
      }),
    ],
  });
}

function progressiveMenu(): MenuItem {
  const progressiveMenuItem: MenuItem = new MenuItem({
    id: "progressives",
    state: "main.machines.progressives.progressiveDefinitions",
    display: "Progressives",
    imgSrc: require("../menu/img/progressives.png"),
    requiredPermission: "machines.progressives.read",
    activeOnState: "main.machines.progressives.progressiveDefinitions.**",
    children: [
      new MenuItem({
        id: "progressives.controllers",
        state: "main.machines.progressives.controllers",
        activeOnState: "main.machines.progressives.controllers.**",
        display: "Controllers",
      }),
      new MenuItem({
        id: "progressives.meterReadingSettings",
        state: "main.machines.progressives.meterReadingSettings",
        activeOnState: "main.machines.progressives.meterReadingSettings.**",
        display: "Meter Reading Settings",
      }),
      new MenuItem({
        id: "progressives.progressiveReadingValidationSettings",
        state:
          "main.machines.progressives.progressiveReadingValidationSettings",
        activeOnState:
          "main.machines.progressives.progressiveReadingValidationSettings.**",
        display: "Validation Settings",
      }),
      new MenuItem({
        id: "progressives.progressiveDailyReading",
        state:
          "main.machines.progressives.progressiveDailyReading.dailyReadings",
        display: "Daily Readings",
      }),
      // new MenuItem({
      //   id: "progressives.escrowReadings",
      //   state: "main.machines.progressives.escrowReadings.readings",
      //   activeOnState: "main.machines.progressives.escrowReadings.**",
      //   display: "Escrow Readings",
      // }),
      // new MenuItem({
      //   id: "progressives.escrowReadingSettings",
      //   state: "main.machines.progressives.escrowReadingSettings",
      //   activeOnState: "main.machines.progressives.escrowReadingSettings.**",
      //   display: "Escrow Reading Settings",
      // }),
    ],
  });

  return progressiveMenuItem;
}

function machineMenu(
  clientName: string,
  applicationInfo: ApplicationInfo
): MenuItem {
  
  const machineMenuItem: MenuItem = new MenuItem({
    id: "machines",
    state: "main.machines.grid",
    display: "Machines",
    requiredPermission: "machineView",
    imgSrc: require("../menu/img/slot_file_icon.png"),
    activeOnState: "main.machines.**",
    excludeActiveOnState: "main.machines.progressives.**",
  });

  if (["gateway", "sycuan", "threeRivers"].includes(clientName)) {
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.lookups",
        state: "main.machines.lookups",
        display: "Lookup Management",
      })
    );
  }

  if (clientName === "sycuan") {
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.softwareGrid",
        state: "main.machines.softwareGrid",
        display: "Game Software",
      })
    );
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.process",
        state: "main.machines.process",
        display: "Process",
      })
    );
  }

  if (clientName === "threeRivers") {
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.typeId",
        state: "main.machines.typeId",
        display: "Type Library",
      })
    );
  }

  if (clientName === "soboba") {
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.configurationType",
        state: "main.machines.configurationType",
        display: "Configuration Type Library",
      })
    );
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.software",
        state: "main.machines.software",
        display: "Machine Software",
      })
    );
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.lookups",
        state: "main.machines.lookups",
        display: "Lookup Management",
      })
    );
  }

  if (clientName === "sanManuel" || clientName === "cachecreek") {
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.configurationType",
        state: "main.machines.configurationType",
        display: "Configuration Type Library",
      })
    );
    if (clientName === "cachecreek") {
      machineMenuItem.addChild(
        new MenuItem({
          id: "machines.process",
          state: "main.machines.process",
          display: "Process",
        })
      );
    }
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.software",
        state: "main.machines.software",
        display: "Machine Software",
      })
    );
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.files",
        state: "main.machines.files",
        display: "Machine Files",
      })
    );
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.lookups",
        state: "main.machines.lookups",
        display: "Lookup Management",
      })
    );
  }

  if (clientName === "graton") {
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.configurationType",
        state: "main.machines.configurationType",
        display: "Configuration Type Library",
      })
    );
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.software",
        state: "main.machines.software",
        display: "Machine Software",
      })
    );
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.lookups",
        state: "main.machines.lookups",
        display: "Lookup Management",
      })
    );
  }

  if (clientName === "gateway") {
    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.progressives",
        state: "main.machines.progressives",
        display: "Progressives",
      })
    );

    machineMenuItem.addChild(
      new MenuItem({
        id: "machines.software",
        state: "main.machines.software",
        display: "Machine software",
      })
    );
  }

  // if (clientName === "desertDiamond") {
  //   machineMenuItem.addChild(
  //     new MenuItem({
  //       id: "main.machines.process",
  //       state: "main.machines.process",
  //       display: "Processes",
  //     })
  //   );
  // }

  if (applicationInfo.isModuleLoaded("machines.depreciation")) {
    machineMenuItem.addChild(depreciationgridMenu());
  }

  return machineMenuItem;
}

function depreciationgridMenu(): MenuItem {
  const depreciationMenuItem: MenuItem = new MenuItem({
    id: "depreciation",
    state: "main.depreciation.grid",
    display: "Depreciation",
    imgSrc: "/res/slot_file_icon.png",
  });

  return depreciationMenuItem;
}

function contractMenu(
  clientName: string,
  applicationInfo: ApplicationInfo
): MenuItem | undefined {
  if (
    !["threeRivers", "desertDiamond", "cachecreek"].find(
      (c) => c === clientName
    )
  ) {
    return undefined;
  }
  const contractMenuItem: MenuItem = new MenuItem({
    id: "contract",
    state: "main.contract",
    display: "Contracts",
    imgSrc: require("../menu/img/slot_file_icon.png"),
    activeOnState: "main.contract.**",
    requiredPermission: "contractView",
  });
  contractMenuItem.addChild(
    new MenuItem({
      id: "contract.lookups",
      state: "main.contract.lookups",
      display: "Lookup Management",
    })
  );
  return contractMenuItem;
}

function contactBookMenu(
  clientName: string,
  applicationInfo: ApplicationInfo
): MenuItem | undefined {
  const contactBookMenuItem: MenuItem = new MenuItem({
    id: "contactBook",
    state: "main.contactBook.grid",
    imgSrc: require("../menu/img/up_down_arrow.png"),
    activeOnState: "main.contactBook.**",
    display: "Contact Book",
  });
  contactBookMenuItem.addChild(
    new MenuItem({
      id: "contactBook.lookups",
      state: "main.contactBook.lookups",
      display: "Lookup Management",
    })
  );
  return contactBookMenuItem;
}
function projectCostMenu(
  clientName: string,
  applicationInfo: ApplicationInfo
): MenuItem | undefined {
  const projectCostMenuItem: MenuItem = new MenuItem({
    id: "project",
    state: "main.project",
    imgSrc: require("../menu/img/up_down_arrow.png"),
    display: "Project",
    requiredPermission: "projectView",
  });
  projectCostMenuItem.addChild(
    new MenuItem({
      id: "projectCost",
      state: "main.projectcost",
      display: "Project Cost",
      requiredPermission: "projectCostView",
    })
  );
  projectCostMenuItem.addChild(
    new MenuItem({
      id: "projectCost.lookups",
      state: "main.project.lookups",
      display: "Lookup Management",
      requiredPermission: "projectCostLookupModify",
    })
  );
  return projectCostMenuItem;
}
